import { MAX_LENGTH_CHAR } from "@/common/constants";

const capitalizeFirstLetter = (input: string): string => {
    return input ? input.charAt(0).toUpperCase() + input.slice(1) : input;
}

const ellipsis = (input: string) => {
    return input && input.length > MAX_LENGTH_CHAR
        ? `${input.slice(0, MAX_LENGTH_CHAR)} ...`
        : input;
}

const formattedRoleName = (role: string) => {
    return role?.split(' ')
        .map(capitalizeFirstLetter)
        .join(' ') || '';
}

const getFilename = (contentDisposition: any) => {
    const parts = contentDisposition.split(';');

    for (const part of parts) {
        const trimmedPart = part.trim();
        if (trimmedPart.startsWith('filename=')) {
            return trimmedPart.split('=')[1].replace(/"/g, '');
        }
    }

    return 'downloaded_file.pdf';
}

export {
    capitalizeFirstLetter,
    ellipsis,
    formattedRoleName,
    getFilename
}
